/*global diy, Klazz*/

// This is a webpack preprocessing instruction, it is not a real variable
__webpack_public_path__ = diy.web.jsBaseUrl;
var sectionsWeb = require('./module/section/web/index');

function initLegacy() {
    window.Modul = Klazz.extend({
        moduleId: null,
        initialize: function(moduleId){ this.moduleId = moduleId; }
    });
    window.mm = {};
}

initLegacy();

diy.core.namespace('diy.module.section').initWeb = sectionsWeb.initWeb;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/init-web-common.js
 ** module id = 1167
 ** module chunks = 5 12
 **/